<template>
	<div class="menu-icon-wrapper">
		<img class="menu-icon" src="@/assets/lp/menu_icon.png" alt="menu">
	</div>
</template>

<script>
export default {
	name: 'MenuButton'
}
</script>

<style lang="scss" scoped>
.menu-icon-wrapper {
	width: 24px;
	.menu-icon {
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/MenuButton.vue